import { createContext } from 'react'
import type { NodeFileManagerHost } from './file-manager-host'

export const NodeFileManagerContext = createContext<NodeFileManagerHost | null>(null)
